import Article from './Article'

const ArticleWrapper = () => {
  return <Article />
}

export default ArticleWrapper
